/**
 * 导出默认通用配置
 *
 * @author Shigq
 * @date 2020/12/3 19:07
 */
import { useI18n } from '@/plugins/i18n'
const { t } = useI18n()
const setting = {
  // 标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
  title: t('global.content.text_1'),
  // 开发环境端口号
  devPort: '8080',
  // 不经过token校验的路由
  routesWhiteList: ['/login', '/register', '/forgetPassword', '/404', '/user/personal', '/register-success'],
  // token名称 - 根据系统来（和顶级域名下token重名，会有问题，建议单独设置）
  tokenName: 'sampToken',
  imgType: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff'],
  pdfType: ['.pdf'],
  docsType: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.wps'],
  docType: ['.doc', '.docx', '.wps'],
  xlsType: ['.xls', '.xlsx'],
  pptType: ['.ppt', '.pptx'],
  txtType: ['.txt'],
  compressType: ['.zip', '.7z', '.rar'],
  videoType: ['.wmv', '.asf', '.asx', '.rm', '.rmvb', '.mp4', '.3gp', '.mov', '.m4v', '.avi', '.dat', '.mkv', '.flv', '.vob']
}

module.exports = setting
